<template>
    <v-container>
        <v-row>
            <v-col>
                Søk etter organisasjon:
                <v-text-field filled :tabindex="tabindex" v-model="search" label="organisasjonsnavn eller -nummer" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
                <!-- <v-data-table height="300" @update:page="pageUpdated" v-model="selection" :items="organisations" item-key="registrationNumber" :headers="headers" :options.sync="options" :server-items-length="totalOrganisations" selectable-key="registrationNumber" show-select single-select :mobile-breakpoint="0" :loading="loading"> -->
                <!-- <v-data-table @update:page="pageUpdated" v-model="selection" :items="organisations" item-key="registrationNumber" :headers="headers" :options.sync="options" :server-items-length="totalOrganisations" selectable-key="registrationNumber" show-select single-select :mobile-breakpoint="0" :loading="loading"> -->

                <v-data-table @update:page="pageUpdated" v-model="selection" :items="organisations" item-key="registrationNumber" :headers="headers" :options.sync="options" :server-items-length="totalOrganisations" selectable-key="registrationNumber" show-select single-select :mobile-breakpoint="0" :loading="loading">
                    <template v-if="selection.length == 0" v-slot:footer>
                        <v-fade-transition mode="in-out">
                            <div class="caption text-no-wrap red--text">organisasjon ikke valgt</div>
                        </v-fade-transition>
                    </template>
                </v-data-table>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
export default {
    props: {
        tabindex: {
            default: 1
        },
        registrationNumber: {
            default: undefined
        }
    },
    data() {
        return {
            search: "",
            searchTimer: null,
            selection: [],
            organisations: [],
            headers: [
                { text: "Navn", value: "name", width: "75%" },
                { text: "Org.nummer", value: "registrationNumber", width: "25%" }
            ],
            totalOrganisations: 0,
            options: {
                page: 1,
                itemsPerPage: 5,
            },
            loading: false
        };
    },
    watch: {
        selection: function(selectionArray) {
            if (selectionArray.length == 1) {
                this.$emit("organisation", selectionArray[0]);
                return;
            }

            if (selectionArray.length == 0) {
                this.$emit("organisation", undefined);
                return;
            }
        },
        search: function() {
            clearTimeout(this.searchTimer);

            if (this.search && this.search.trim().length > 0) {
                this.searchTimer = setTimeout(() => {
                    this.selection.splice(0);
                    this.totalOrganisations = 0;
                    this.options = { page: 1, itemsPerPage: 5 };
                    this.getOrganisations();
                }, 1000);
            } else {
                this.selection.splice(0);
                this.totalOrganisations = 0;
                this.options = { page: 1, itemsPerPage: 5 };
                this.organisations.splice(0);
            }
        }
        // options() {
        //     this.getOrganisations();
        // }
    },
    methods: {
        pageUpdated() {
            this.getOrganisations();
        },
        getOrganisations() {
            this.loading = true;

            let params = {
                page: this.options?.page ? this.options.page - 1 : 0,
                size: this.options?.itemsPerPage || 5
            };

            let regNum = this.search.replace(/\s/g, "");

            if (regNum.length >= 9 && !isNaN(regNum)) {
                params.registrationnumber = Number(regNum);
            } else {
                params.name = this.search;
            }

            axios
                .get("/brreg", {
                    params
                })
                .then(response => {
                    this.totalOrganisations = response.data.totalOrganisations;
                    // this.organisations = response.data.organisations;
                    this.$nextTick(() => {
                        this.organisations.splice(0);
                        this.organisations.push.apply(this.organisations, response.data.organisations)
                        // this.organisations = response.data.organisations
                    })

                    if (this.organisations.length == 1) {
                        this.selection.push(this.organisations[0]);
                    }
                })
                .catch(errorResponse => {
                    // if("snackbar" in this.$store.commit){
                    this.$store.commit("snackbar", { show: true, text: `${errorResponse.status}: ${errorResponse.statusText}`, color: "error" });
                    // }
                    // else{
                    //     console.error(errorResponse);
                    // }
                })
                .then(() => {
                    this.loading = false;
                });
        }
    },
    mounted() {
        if (this.registrationNumber) {
            this.search = this.registrationNumber;
        }
    }
};
</script>

<style lang="scss" scoped>
.v-data-footer__select {
    visibility: hidden;
}
</style>